<template>
  <div>
    <ContentsHeader>
      <template v-slot:title01>{{jobName}}</template>
      <template v-slot:explain01>
        投資信託や外貨預金など金融商品の提案を行う他、預金業務や現金の融資などさまざまな項目で契約に結びつけるのが銀行の営業職です。個人法人問わず顧客のニーズにあわせて継続的なサポートが求められる他、資金運用の提案などコンサルティング営業に近い業務を求められる仕事です。正確慎重な作業と専門的な知識が必要なこの業界の営業職にはどのような特徴が見られるのでしょうか。
      </template>
      <template v-slot:yarigai01><span class="ddin">仕事を通して本当にいろんな勉強ができます</span><span class="ddin">(千葉県 28歳 女性)</span></template>
      <template v-slot:yarigai02><span class="ddin">無形商材を通して顧客のニーズに応えることができること</span><span class="ddin">(大阪府 38歳 男性)</span></template>
      <template v-slot:yarigai03><span class="ddin">自分の仕事が地域経済を支えていると思うと嬉しい</span><span class="ddin">(北海道 32歳 男性)</span></template>
      <template v-slot:img-headbg><img src="../assets/img/bank/headbg.svg" :alt="jobName" class="img -bank"></template>
      <template v-slot:img-headp><img src="../assets/img/bank/person.svg" :alt="jobName" class="imgp -bank"></template>
    </ContentsHeader>

    <div class="contents-block">

      <section class="job-section">
        <div class="jsinner">
          <div class="block-two -aistretch -jcsb -bptablet">
            <div class="block -b48p -p0">
              <BalanceChartSection :explain="bcExplain" :radarData="radarData"></BalanceChartSection>
            </div>
            <div class="block -b48p -p0">
              <JobChangeRateSection
                :explain="jcExplain"
                :doughnutData="doughnutData"
                :doughnutDataFake="doughnutDataFake"
              ></JobChangeRateSection>
            </div><!-- .block -->
          </div><!-- .block-two -->
        </div><!-- .jsinner -->
      </section>

      <PersonalCharaSection :sevenData="sevenData" :secTtl="'銀行業界'" >
        <template v-slot:feature>規律を重視する自信家</template>
        <template v-slot:imgpup><img src="../assets/img/bank/person.svg" alt="銀行の営業の営業" class="imgcvperson -bank"></template>
      </PersonalCharaSection>
    
      <div class="lb-area">
        <div class="lbinner block-two -bptablet">
          <div class="block">
            <CareerTypeSection :graphData="graphData" :explain="ctExplain" :jobName="'銀行'"></CareerTypeSection>
          </div><!-- .block -->
          <div class=" block">
            <SalesTypeSection :graph2Data="graph2Data" :explain="stExplain" :jobName="'銀行'"></SalesTypeSection>
          </div><!-- .block -->
        </div><!-- .block-two -->
      </div><!-- .lb-area -->

      <ResultSection :job="'bank'">
        <template v-slot:jobname>銀行の営業</template>
        <template v-slot:title01>努力型の自信家</template>
        <template v-slot:explain01>
      自信家で、勤勉な傾向が高いことが分かります。<br>
コツコツと物事に取り組むことに長けており、積み上げた努力に裏打ちされた自信は、資産を預けてもらう顧客に対し、安心感を与える重要な能力であると考えられます。
        </template>
        <template v-slot:title02>安定のための知識</template>
        <template v-slot:explain02>
キャリアの安定を重視する人が多いことが分かります。専門的な知識が必要な業界ではありますが、スペシャリスト志向は低く、転職経験者が少ないことからも、「知識を深める」ことよりも、「一つの組織で長く働く」ことをモチベーションに知識や資格を習得していると考えられます。        </template>
        <template v-slot:imgperson><img src="../assets/img/bank/person.svg" alt="銀行の営業の営業" class="rsimg"></template>
      </ResultSection>

      <section class="other-section">
        <h2 class="osttl">その他の業界ごとの詳細をのぞく</h2>
        <div class="osinner">
          <DetailsList :job="'bank'"></DetailsList>
        </div><!-- .osinner -->
      </section>

    </div><!-- contents-block -->
  </div>

</template>

<script>

import ContentsHeader from "../components/ContentsHeader.vue";
import ResultSection from "../components/ResultSection.vue";
import DetailsList from "../components/DetailsList.vue";

import BalanceChartSection from "../components/BalanceChartSection.vue";
import JobChangeRateSection from "../components/JobChangeRateSection.vue";
import PersonalCharaSection from "../components/PersonalCharaSection.vue";
import CareerTypeSection from "../components/CareerTypeSection.vue";
import SalesTypeSection from "../components/SalesTypeSection.vue";

export default {
  data() {
    return {
      pageTitle: "銀行の営業をのぞく",
      pageURL: "bank",
      pageDescription: "SALES SALES SCOPEでは不動産、保険、ITなど人気10業界の営業職に人物特性と成績に関する調査を実施。投資信託や外貨預金など金融商品の提案を行う他、預金業務や現金の融資などさまざまな項目で契約に結びつけるのが銀行の営業職です。正確慎重な作業と専門的な知識が必要なこの業界の営業職にはどのような特徴が見られるのでしょうか。",

      jobName: "銀行の営業",
      bcExplain: "全ての項目がバランスよく高い",
      jcExplain: "転職回数はかなり少ない",
      pcExplain: "規律を重視する自信家",
      ctExplain: "安定・保障された身分を望む安定タイプが多い\n自律裁量を求める自律行動タイプは少ない",
      stExplain: "顧客と親密な関係を築こうとするタイプは少なく、提案をどのように伝えるかを重視するタイプが多い",
      radarData: [7.59, 6.58, 7.81, 8.45, 7.09],
      doughnutData: [77, 8, 7, 3, 5],
      doughnutDataFake: [76, 7, 7, 3, 7],
      sevenData: [4, 2, 6, 4, 3, 5, 5],
      graphData: [
        { num: 1, val: 12 },
        { num: 2, val: 8 },
        { num: 3, val: 3 },
        { num: 4, val: 30 },
        { num: 5, val: 4 },
        { num: 6, val: 19 },
        { num: 7, val: 12 },
        { num: 8, val: 12 },
      ],
      graph2Data: [
        { num: 1, val: 4 },
        { num: 2, val: 44 },
        { num: 3, val: 32 },
        { num: 4, val: 4 },
        { num: 5, val: 16 },
      ],
    };
  },
  components: {
    BalanceChartSection,
    JobChangeRateSection,
    PersonalCharaSection,
    CareerTypeSection,
    SalesTypeSection,
    ContentsHeader,
    ResultSection,
    DetailsList
  },
  metaInfo: {
    title: "銀行の営業をのぞく | 営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },
  },
  mounted: function(){
    // document.title = title;
    document.querySelector("meta[name='description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:title']").setAttribute('content', this.pageTitle + " | 営業職の特徴を人物特性からのぞいてみた | SALES SCOPE");
    document.querySelector("meta[property='og:description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:url']").setAttribute('content', 'https://sales-score.jp/scope/' + this.pageURL);
  }
};
</script>